import React from 'react'
import {
  Box,
  VStack,
  HStack,
  Text,
  Progress,
  Heading,
  Card,
  Badge
} from '@chakra-ui/react'

interface VisibilityScoreProps {
  score: number
  breakdown?: {
    completeness: number
    quality: number
  }
  recommendations?: Array<{
    action: string
    potential_increase: number
    category: string
  }>
  showBreakdown?: boolean
  showRecommendations?: boolean
}

export const VisibilityScore: React.FC<VisibilityScoreProps> = ({
  score,
  breakdown,
  recommendations = [],
  showBreakdown = false,
  showRecommendations = false
}) => {
  const getScoreColor = (value: number) => {
    if (value >= 80) return 'green'
    if (value >= 60) return 'blue'
    if (value >= 40) return 'yellow'
    return 'red'
  }

  return (
    <Card.Root w="full">
      <Card.Body p={6}>
        <VStack gap={4} align="stretch">
          {/* Main Score */}
          <VStack gap={2} align="center">
            <Text fontSize="sm" color="gray.600" fontWeight="medium">
              Your Visibility Score
            </Text>
            <Heading size="4xl" color={`${getScoreColor(score)}.600`}>
              {score}%
            </Heading>
            <Progress.Root value={score} colorPalette={getScoreColor(score)} size="lg" w="full">
              <Progress.Track borderRadius="full">
                <Progress.Range />
              </Progress.Track>
            </Progress.Root>
          </VStack>

          {/* Breakdown */}
          {showBreakdown && breakdown && (
            <VStack gap={2} align="stretch" pt={4} borderTopWidth="1px" borderColor="gray.200">
              <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                Score Breakdown
              </Text>
              <HStack justify="space-between">
                <Text fontSize="sm" color="gray.600">Completeness</Text>
                <Text fontSize="sm" fontWeight="semibold" color="gray.900">
                  {breakdown.completeness}%
                </Text>
              </HStack>
              <Progress.Root value={breakdown.completeness} colorPalette="blue" size="sm">
                <Progress.Track borderRadius="full">
                  <Progress.Range />
                </Progress.Track>
              </Progress.Root>
              <HStack justify="space-between">
                <Text fontSize="sm" color="gray.600">Quality</Text>
                <Text fontSize="sm" fontWeight="semibold" color="gray.900">
                  {breakdown.quality}%
                </Text>
              </HStack>
              <Progress.Root value={breakdown.quality} colorPalette="purple" size="sm">
                <Progress.Track borderRadius="full">
                  <Progress.Range />
                </Progress.Track>
              </Progress.Root>
            </VStack>
          )}

          {/* Recommendations */}
          {showRecommendations && recommendations.length > 0 && (
            <VStack gap={2} align="stretch" pt={4} borderTopWidth="1px" borderColor="gray.200">
              <Text fontSize="sm" fontWeight="semibold" color="gray.700">
                How to Improve
              </Text>
              {recommendations.slice(0, 5).map((rec, index) => (
                <HStack key={index} justify="space-between" align="start">
                  <Text fontSize="sm" color="gray.600" flex={1}>
                    {rec.action}
                  </Text>
                  <Badge colorPalette="green" size="sm">
                    +{rec.potential_increase}%
                  </Badge>
                </HStack>
              ))}
            </VStack>
          )}
        </VStack>
      </Card.Body>
    </Card.Root>
  )
}







